(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__solCartUp) return;
    window.__solCartUp = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sol-add]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.getAttribute('data-sol-add')), quantity: 1 }],
          sections: 'cart-drawer-section'
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          var html = data && data.sections && data.sections['cart-drawer-section'];
          var cur = document.querySelector('#cart-drawer .cart-drawer__inner');
          if (html && cur) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.cart-drawer__inner');
            if (fresh) { cur.replaceWith(fresh); return; }
          }
          window.location.reload();
        })
        .catch(function () { window.location.reload(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
